import { useBrandLoaderData } from "../../../root/rootLoader.ts";
import { Helmet } from "react-helmet-async";

function getTitle(brand: string, title?: string) {
  return title ? brand + ": " + title : brand;
}

export default function PageTitle({
  title,
  noHeading,
}: {
  title?: string;
  noHeading?: boolean;
}) {
  const brand = useBrandLoaderData();

  return (
    <>
      <Helmet>
        <title>{getTitle(brand.brand, title)}</title>
      </Helmet>
      {!noHeading && <h1>{title}</h1>}
    </>
  );
}
